import 'css-chunk:src/index/components/workers_icon/workers_icon.module.scss';export default {
  "descriptionHeader": "descriptionHeader__MmYSM",
  "description": "description__48Rmw",
  "detail": "detail__UUP-w"
};